export default __webpack_public_path__ + "static/media/dr-ramya-prakash.ddef0438.png";